import React from "react";
import classes from "./privacyPolicy.module.css";
import Footer from "../../components/footer";

const PrivacyPolicy = () => {
  return (
    <>
      <div className={classes.policyContainer}>
        <div className={classes.policyWrapper}>
          <h1>Privacy Policy for Artist Next Door</h1>
          <p>
            <strong>Last Updated: 22nd March 2025</strong>
          </p>
          <p>
            Welcome to Artist Next Door! Your privacy is important to us. This
            Privacy Policy explains how we collect, use, share, and protect your
            information when you use our platform.
          </p>

          <h2>1. Why We Collect Your Data</h2>
          <ul>
            <li>
              Connecting you with opportunities – helping artists and event
              organizers find the right match.
            </li>
            <li>
              Personalizing your experience – recommending content and
              interactions tailored to you.
            </li>
            <li>
              Ensuring platform security – preventing fraud, spam, and
              unauthorized access.
            </li>
            <li>
              Enhancing our services – analyzing usage patterns to improve
              Artist Next Door.
            </li>
          </ul>

          <h2>2. What Data We Collect</h2>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, email, phone number
              (for account creation and communication).
            </li>
            <li>
              <strong>Artist Profile Details:</strong> Your skills, past
              performances, location, availability, and social links.
            </li>
            <li>
              <strong>Payment Information:</strong> Processed securely by
              third-party processors.
            </li>
            <li>
              <strong>Usage Data:</strong> Interaction with our platform,
              preferences, and browsing history.
            </li>
          </ul>

          <h2>3. Who We Share Your Data With</h2>
          <ul>
            <li>Event organizers looking to book artists.</li>
            <li>Secure payment processors to facilitate transactions.</li>
            <li>
              Trusted third-party services like analytics tools and hosting
              services.
            </li>
            <li>Legal authorities if required by law.</li>
          </ul>
          <p>
            <strong>
              We do not sell your data to third-party advertisers or marketing
              agencies.
            </strong>
          </p>

          <h2>4. Your Rights and Choices</h2>
          <ul>
            <li>
              Edit or update your profile anytime from your account settings.
            </li>
            <li>
              Request data deletion if you no longer wish to use Artist Next
              Door.
            </li>
            <li>Download a copy of your data for your records.</li>
            <li>Adjust privacy settings to control profile visibility.</li>
          </ul>
          <p>
            For any requests, email us at{" "}
            <strong>[Insert Contact Email]</strong> and we’ll process it as
            quickly as possible.
          </p>

          <h2>5. How We Keep Your Data Secure</h2>
          <ul>
            <li>
              Encryption protocols to safeguard personal and payment
              information.
            </li>
            <li>Secure servers to prevent unauthorized access.</li>
            <li>
              Access restrictions ensuring only necessary personnel can handle
              sensitive data.
            </li>
            <li>
              Regular security updates to stay ahead of potential threats.
            </li>
          </ul>

          <h2>6. Cookies and Tracking Technologies</h2>
          <p>Like most platforms, we use cookies to:</p>
          <ul>
            <li>Store your preferences and login sessions.</li>
            <li>
              Understand how you interact with our platform to improve
              usability.
            </li>
            <li>Offer a personalized experience based on your activity.</li>
          </ul>
          <p>
            You can disable cookies in your browser settings, but this may
            impact your experience.
          </p>

          <h2>7. Updates to This Privacy Policy</h2>
          <p>
            We may update this policy from time to time to reflect new features,
            legal requirements, or security improvements. We’ll notify you of
            major changes via email or through our platform.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
